module.exports = __webpack_public_path__ + "img/card-star-enable.78a75b68.png";